import { User } from '../auth/User';

export class Category {

	public id: number;
	public name: string = '';
	public description: string = '';
	public isEnabled: boolean;
	public isFeatured: boolean;
	public createdBy: User;
	public lastUpdatedBy: User;
	public createdDate: Date;
	public updatedDate: Date;

	constructor(init?: Partial<Category>) {
		Object.assign(this, init);
	}


}
